import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import ButtonDefault from '@/components/ui/ButtonDefault';
import * as S from './styles';

interface ModalDeleteProps {
	open?: boolean;
	loading?: boolean;
	reportName?: string;
	isFromReview?: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export function ModalDelete({
	open = false,
	loading = false,
	reportName = '',
	isFromReview = false,
	onConfirm,
	onCancel
}: Readonly<ModalDeleteProps>): JSX.Element {
	function getDeleteMessage(): string {
		if (isFromReview) {
			return `${I18n.get('Do you want to delete the Initial Version of the evaluation')} "${reportName}"?`;
		}

		return `${I18n.get('Do you want to delete the evaluation')} "${reportName}" ${I18n.get(
			'and all its versions'
		)}?`;
	}

	return (
		<S.ModalWrapper open={open} centered width={500} footer={null} onCancel={onCancel}>
			<Row justify="center" gutter={[0, 16]}>
				<Col>
					<S.DeleteIcon />
				</Col>
				<Col span={24}>
					<S.Description>{getDeleteMessage()}</S.Description>
				</Col>
				<Col span={24}>
					<Row justify="center" gutter={[16, 0]}>
						<Col>
							<ButtonDefault key="back" onClick={onCancel}>
								{I18n.get('Cancel')}
							</ButtonDefault>
						</Col>
						<Col>
							<ButtonDefault type="primary" loading={loading} onClick={onConfirm}>
								{I18n.get('Yes')}
							</ButtonDefault>
						</Col>
					</Row>
				</Col>
			</Row>
		</S.ModalWrapper>
	);
}
